export default __webpack_public_path__ + "static/media/pc_background2.f6b79215.png";